(ns common.fields.templates.company-schema
  (:require
   [common.schema.data-types :as data-types]
   [common.schema.registry :as registry]
  ))

(defn company-schema
  [tenant-schema]
  {:cards [{:card-name "Company webentry"
            :card-key  "company-webentry-card"
            :expanded  "closed"
            :fields    [(->> :entity.type/company
                             (registry/get-schema tenant-schema)
                             (remove (fn [[k fs]]
                                       (-> fs
                                           :field/data-type
                                           (= :data.type/currency-symbol))))
                             (map (fn [[k fs]]
                                    {:field-name (->> fs
                                                      :field/translations
                                                      :en)
                                     :field-key  (str (namespace k) "-" (name k))
                                     :type       (data-types/to-webform-type (:field/data-type fs))
                                     :entity     :company
                                     :attribute  k
                                     :ord        (:field/default-ord fs)
                                     :size       {:xs 12}}))
                             (sort-by :ord))]}]})
